module.exports = __webpack_public_path__ + "img/horizontal_4_5_6000.7363ae07.png";